export function getJobsCollectionName(isDev: boolean): string {
  return isDev ? 'jobsDev' : 'jobs';
}
